import React, { memo } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { FallbackView } from '../FallbackView';
import ErrorIcon from '../../public/static/images/search/icons/icon-error.svg';

interface Props {
  onRetry?: () => void;
}

export const SectionError: React.FC<Props> = memo(({ onRetry }) => {
  const { t } = useTranslation();
  const router = useRouter();

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      router.reload();
    }
  };

  return (
    <FallbackView
      Icon={ErrorIcon}
      width={50}
      height={50}
      text={t('search.error.text')}
      title={t('search.error.title')}
      btnText={t('search.error.link')}
      onClickHandler={handleRetry}
    />
  );
});

SectionError.displayName = `SectionError`;
